import { createSelector } from "@ngrx/store";
import * as AuthenticationSelectors from "@app/shared/state/authentication/authentication.selectors";
import * as SupplierSelectors from "@app/shared/state/supplier/supplier.selectors";
import { Constants } from "@app/constants/constants";

export const selectShouldDisplayManageDraftSuppliersMenu = createSelector(
  AuthenticationSelectors.selectUserType,
  AuthenticationSelectors.selectIsUserEmployee,
  SupplierSelectors.selectDraftSupplierEsns,
  (userType, isUserEmployee, draftSupplierEsns) => {
    return (
      (userType && userType === "broker") ||
      draftSupplierEsns.length > 0 ||
      isUserEmployee
    );
  },
);

export const selectShouldDisplayManageActiveSuppliersMenu = createSelector(
  AuthenticationSelectors.selectUserType,
  AuthenticationSelectors.selectIsUserEmployee,
  SupplierSelectors.selectEnterpriseSuppliers,
  (userType, isUserEmployee, enterpriseSuppliers) => {
    return (
      (userType && userType === "broker") ||
      (enterpriseSuppliers.length > 0 &&
        enterpriseSuppliers.some(
          (supplier) =>
            supplier.esn !== Constants.DraftPlaceholderEsn &&
            supplier.status?.toLowerCase() === "active",
        )) ||
      isUserEmployee
    );
  },
);

export const selectShouldDisplayManageProductsProductsMenu = createSelector(
  AuthenticationSelectors.selectIsUserEmployee,
  SupplierSelectors.selectDraftSupplierEsns,
  SupplierSelectors.selectDraftEsnsWithProducts,
  SupplierSelectors.selectEnterpriseSuppliers,
  (
    isUserEmployee,
    draftSupplierEsns,
    draftEsnsWithProducts,
    enterpriseSuppliers,
  ) => {
    return (
      isUserEmployee ||
      (draftSupplierEsns.length > 0 &&
        draftEsnsWithProducts.some((esn) => draftSupplierEsns.includes(esn))) ||
      enterpriseSuppliers.some(
        (supplier) =>
          supplier.esn !== Constants.DraftPlaceholderEsn &&
          supplier.status?.toLowerCase() === "active",
      )
    );
  },
);

export const selectHasCustomPromotionsAccess =
  AuthenticationSelectors.selectDoesUserHaveAnyAction([
    Constants.UserActions.CustomPromotionsRead,
    Constants.UserActions.CustomPromotionsCreate,
    Constants.UserActions.CustomPromotionsDelete,
    Constants.UserActions.CustomPromotionsFinalize,
    Constants.UserActions.CustomPromotionsUpdate,
    Constants.UserActions.CustomPromotionsAdminUpdate,
    Constants.UserActions.CustomPromotionsAdminRead,
    Constants.UserActions.CustomPromotionsItAdmin,
  ]);
